import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useState } from 'react';
import * as authApi from '../api/auth';
import { blockedMessage } from '../lib/accessBlock';
import { setToken, setRefreshToken, clearTokens, getToken } from '../lib/auth';
export const AuthContext = createContext({
    user: null,
    isLoading: true,
    isAuthenticated: false,
    login: () => Promise.reject(),
    logout: () => { },
});
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const token = getToken();
        if (!token) {
            setIsLoading(false);
            return;
        }
        authApi.getMe()
            .then((me) => {
            // Espace bloqué depuis la dernière visite : retour à la connexion.
            if (blockedMessage(me))
                clearTokens();
            else
                setUser(me);
        })
            .catch(() => clearTokens())
            .finally(() => setIsLoading(false));
    }, []);
    const login = useCallback(async (email, password) => {
        const tokens = await authApi.login(email, password);
        setToken(tokens.token);
        setRefreshToken(tokens.refresh_token);
        const me = await authApi.getMe();
        setUser(me);
        return me;
    }, []);
    const logout = useCallback(() => {
        clearTokens();
        setUser(null);
    }, []);
    return (_jsx(AuthContext.Provider, { value: { user, isLoading, isAuthenticated: !!user, login, logout }, children: children }));
}
